import { Flex, Skeleton } from "antd"
import { usePropertyPhotosQuery } from "./attachmentsQueries"
import './ImagePicker.css'

export type Props = {
  customerId: number
  propertyId: number
  selectedAttachmentId?: string | null
  onAttachmentSelected: (attachmentId: string) => void
}

const ImagePicker = ({customerId, propertyId, selectedAttachmentId, onAttachmentSelected}: Props) => {
  const photosQuery = usePropertyPhotosQuery(customerId, propertyId)
  const data = photosQuery.data ?? []

  if (photosQuery.isLoading) {
    return <Skeleton active />
  }

  if (data.length === 0) {
    return <div className="react-image-picker-empty">There are no items to display</div>
  }

  return <Flex gap={10} wrap="wrap">
    {data.map(attachment => {
      const classNames = ['react-image-picker-item']
      if (selectedAttachmentId === attachment.id) {
        classNames.push('selected')
      }

      return <div key={attachment.id} className={classNames.join(' ')} onClick={() => onAttachmentSelected(attachment.id)}>
        <img src={attachment.thumbnail ?? ''} style={{}} />
      </div>
    })}
  </Flex>
}

export default ImagePicker
